// @flow

import * as React from 'react';

import type { Dispatch, GetState } from '../types';
import { withRouter } from '../helpers/withRouter';
import { fetchUrlTrustpilot } from './modules';
import type { WithRouterProps } from '../helpers/withRouter';
import NotFound from '../containers/NotFound';

function Trustpilot(): React.Element<typeof NotFound> {
  return <NotFound />;
}

Trustpilot.handleRedirect = function handleRedirect(args: {|
  dispatch: Dispatch,
  getState: GetState,
  req: express$Request,
  res: express$Response,
  ...WithRouterProps<{| token: string |}>,
|}): Promise<any> {
  const { token } = args.params;
  const { dispatch, res } = args;

  return dispatch(fetchUrlTrustpilot(token))
    .then(response => {
      res.redirect(response.data.href);
    })
    .catch(() => {
      // For unit test
    });
};

export default (withRouter(Trustpilot): React.ComponentType<{||}> & {|
  handleRedirect: typeof Trustpilot.handleRedirect,
|});
